module.exports = __webpack_public_path__ + "static/fluent-dialog-d55f6a8f01f7b3c4bd1eeeeb2274c9bf.png";